<template>
	<!-- 订单核销 -->
	<div>
		<cube-page type="myorder-view" title="出行信息" :isback="false">
			<div slot="content">
				<div class="vancollapse" v-if="list">
					<van-collapse v-model="activeName" accordion>
						<van-collapse-item title="" :name="0">
							<div class="itembox">
								<div class="itemright ells">
									<div class="itemxx">
										产品：
										<span class="ells">{{ list.goods_name }}</span>
									</div>
									<div class="itemxx">
										规格：
										<span class="ells">{{ list.goods_attr }}</span>
									</div>
									<div class="itemxx">
										使用日期：
										<span>{{ list.travel_time }}</span>
									</div>
									<div class="itemxx">
										客服热线：
										<span>{{ list.hot_line }}</span>
									</div>
									<div style="color: red" class="itemxx itemxx-last">
										<div>行程</div>
										<div>
											<span>车辆信息</span>：{{ list.car_number }}
										</div>
										<div class="itemxx-list">
											<span>司机信息</span>：{{ list.car_driver }} {{ list.car_driver_tel }}
										</div>
										<div class="itemxx-list">
											<div>发车信息：</div>
											<div class="pre">{{ list.car_memo }}</div>
										</div>
									</div>

								</div>
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>
				<div v-else>
					<van-empty description="暂无数据" />
				</div>
			</div>
		</cube-page>
		<cube-view></cube-view>
	</div>
</template>

<script>
import CubeView from '@/components/TP/cube-view'
import CubePage from '../TP/cube-page.vue'
import * as util from '@/utils/network'

export default {
	components: {
		CubePage,
		CubeView,
	},
	data() {
		return {
			list: null,
			code: this.$route.query.code,
			activeName: 0,
		}
	},
	activated() {

	},
	created() {

	},
	mounted() {
		this.onLoad();
	},
	methods: {
		// 请求数据
		onLoad() {
			let url = "/addons/litestore/api.account/getTravel";
			let params = {
				code: this.code,
				page: this.listpage,
			};
			util.post(url, params, (res) => {
				let data = res.data;
				if (!data) {
					return false
				}
				this.list = data;
			});
		},
	}
}
</script>
<style lang="less" scoped="scoped">
@import url("../../assets/css/listboxless.less");

.tt-wirte {
	padding: 20px;
	background-color: #FFFFFF;
}

.vancollapse {
	padding: 15px 15px 80px;
}

.itembox {
	display: flex;
	align-items: center;
	padding: 5px 0;

	.itemleft {
		width: 60px;
	}

	.itemright {
		flex: 1;
		width: 0;
		text-align: center;


		.itemxx {
			line-height: 30px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			color: #666;
		}

		.itemxx-last {
			justify-content: flex-start;
			flex-flow: column;
			text-align: left;
			align-items: flex-start;

			.itemxx-list {
				display: flex;

				.pre {
					white-space: pre-wrap
				}
			}
		}

		.code-img {
			margin: 0 0 15px;

			.van-image {
				width: 200px;
			}
		}
	}

	.itembtns {
		width: 78px;
	}
}

.itembox+.itembox {
	border-top: 1px solid #e5e5e5;
}

.gzh-box {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;

	.tt {
		padding-bottom: 40px;
		margin-top: 5px;
		text-align: center;
		font-weight: 600;
	}
}

.item {
	padding: 20px 40px;
	width: 60%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #00c7bd;
	color: #FFFFFF;

	.remark {
		padding: 25px;
		font-size: 16px;
		font-weight: 600;
	}

	.imgcore {
		margin-top: 15px;
		height: 200px;
		width: 220px;
		border-radius: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.flex {
		display: flex;
		align-items: center;

		.van-icon {
			font-size: 48px;
			padding-right: 10px;
		}
	}

	.msearch {
		margin: 10px 0;
		height: 30px;
		padding: 0 10px;
		line-height: 30px;
		background-color: #fff;
		border-radius: 5px;
		color: #000;
	}
}

/deep/ .van-field__control {
	color: #000 !important;
}
</style>
